// extracted by mini-css-extract-plugin
export default {"error-text":"TermsContent_error-text__mcw96","content-wrapper":"TermsContent_content-wrapper__G-eqL","title":"TermsContent_title__TgWfL"};